module.exports = __webpack_public_path__ + "img/gotoreport.94b7de36.svg";